"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("@/common/components");
function default_1({ channel_thumbnail }) {
    return ((0, jsx_runtime_1.jsx)(components_1.RoundImage, { size: 18, src: channel_thumbnail, altSrc: `${process.env.CDN_URL}/assets/svgs/default_profile.svg`, loading: "lazy" }));
}
exports.default = default_1;
